
export { HorizontalProductCardSkeleton } from "/codebuild/output/src3838206175/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src3838206175/src/packages/shared-components/src/components/ProductCard/index.ts"